import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCourseData } from "../../data/allCourseDetails"; // Import the new mapper
import CourseDetailsSection from "../Common/CourseDetailsSection3";
// import CourseDetailsSection from "../Common/CourseDetailsSection";

function Details() {
  const { slug } = useParams();
  const [selectedCourseData, setSelectedCourseData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      // This calls the appropriate API based on the slug mapping we created
      const data = await getCourseData(slug);
      setSelectedCourseData(data);
      setLoading(false);
    };

    fetchData();
    window.scrollTo(0, 0);
  }, [slug]);

  if (loading) return <div className="text-center py-5">Loading...</div>;

  if (!selectedCourseData) {
    return (
      <div className="container py-5 text-center">
        <h1>Course Not Found</h1>
        <p>We couldn't find details for course: {slug}</p>
      </div>
    );
  }

  return (
    <div className="CourseDetails">
      <CourseDetailsSection data={selectedCourseData} />    
    </div>
  );
}

export default Details;